module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyMCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIG9wYWNpdHk9IjAuNzkiPg0KPHBhdGggZD0iTTE3Ljc0NzIgNC43NzM5M0wxMS40NDczIDEzLjc5OTRMMTcuNzQ3MyAyMy4yMjU5IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTEwLjQ0NzEgMkwyLjI1MjkzIDEzLjczOTFMMTAuNDQ3MSAyNS45OTk5IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9nPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/goPrev.svg
// module id = G7nl
// module chunks = 0